import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const getSystemChecklist = async (communityId: string | number, fiscalYear: string | number) => {
  return await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/system-checks`);
};

const useGetSystemChecklist = ({
  communityId, 
  fiscalYear,
  queryParams
}: {
  communityId?: string | number,
  fiscalYear?: string | number,
  queryParams?: any;
}) =>
  useQuery({
    queryKey: ["system-checklist", communityId, fiscalYear],
    queryFn: () => getSystemChecklist(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    ...queryParams
  });

export default useGetSystemChecklist;